import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=3a6e73ca&scoped=true&"
import script from "./SiteFooter.vue?vue&type=script&lang=js&"
export * from "./SiteFooter.vue?vue&type=script&lang=js&"
import style0 from "./SiteFooter.vue?vue&type=style&index=0&id=3a6e73ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6e73ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFooter,VRow})
